import apolloClient from '@/libs/apollo'
import { formasLeitura } from '@/libs/apollo/queries/leitura'
import LeituraAPI from '@/api/leitura'

export default {
  async fetchFormasLeitura({ commit }) {
    commit('SET_LOADING', true)
    const response = await apolloClient.query({
      query: formasLeitura,
    })
    commit('SET_LOADING', false)
    commit('SET_FORMAS_LEITURA', response.data.formasLeitura)
  },
  clearAll({ commit }) {
    commit('CLEAR_ALL', {})
  },
  save({ commit }, params) {
    return new Promise((resolve, reject) => {
      LeituraAPI.save(params)
        .then(response => {
          commit('SET_LEITURAS', [])
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  fetchLeituras({ commit }, params) {
    commit('SET_LOADING', true)
    commit('SET_LEITURAS', [])
    return new Promise((resolve, reject) => {
      const dtRef = new Date(params.referencia)
      const month = dtRef.getUTCMonth() + 1
      const day = dtRef.getUTCDate()
      const year = dtRef.getUTCFullYear()
      const data = `${year}-${month}-${day}`

      params.data = data

      LeituraAPI.list(params)
        .then(res => {
          commit('SET_LEITURAS', res.data)
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
        .finally(() => {
          commit('SET_LOADING', false)
        })
    })
  },
}
